import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import config from '../../config'
import {
  Link,
  // LinkIcon,
  // Grade
} from '../../components'
import Styles from './TargetDateLinks.css'

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateLinks extends Component {
  static propTypes = {
    strategyName: PropTypes.string,
    funds: PropTypes.array,
  }
  constructor(props){
    super(props)
    this.state = {
      gradeField: {
        'Fossil Free Funds': 'grade_fossil',
        'Deforestation Free Funds': 'grade_deforestation',
        'Gender Equality Funds': 'grade_gender_equality',
        'Gun Free Funds': 'grade_guns',
        'Prison Free Funds': 'grade_prison_industrial_complex',
        'Weapon Free Funds': 'grade_military',
        'Tobacco Free Funds': 'grade_tobacco'
      }[config.app.title] || 'undefined'
    }
  }
  //
  makeUrl = (fund) => {
    const sName = format.sanitize(fund.fund_legal_name)
    const sTicker = fund.ticker || 'N'
    return config.routes.fund + '/' +
      sName + '/' +
      sTicker + '/' + config.profilePath + '/' +
      fund.fund_id + '/' +
      fund.investment_vehicle_id
  }
  //
  hasFunds = () => {
    return (
      this.props.funds &&
      Array.isArray(this.props.funds) &&
      this.props.funds.length > 0
    )
  }
  //
  render() {
    if (!this.hasFunds()) {
      return <div styleName='td-fund-years-wrap'/>
    }
    return <div styleName='td-fund-years-wrap'>
      {
        this.props.funds.map((e, i) => {
          const nameYear = e.fund_legal_name.match(/ 20\d{2}/)
          const eUrl = this.makeUrl(e)
          return <Link
            key={this.props.strategyName + nameYear + ' ' + i}
            to={eUrl}
            title={this.props.strategyName + nameYear + ' | ' + config.app.title}
          >  
            <div styleName={'td-fund-year grade-' + e[this.state.gradeField]}>
              {nameYear ? nameYear[0] : null}
            </div>
          </Link>
        })
      }
    </div>
  }
}
